export const buildPartLabel = (
    part?: string | null,
    position?: string | null,
): string =>
    [position, part]
        .map((v) => (v && v.trim() !== '' && v !== 'N/A' ? v.trim() : ''))
        .filter(Boolean)
        .join(' ');
